<article>
  <ng-container [ngSwitch]="code">
    <ng-template [ngSwitchCase]="'nocontainer'">
      <h2>Container Error</h2>
      <p>
        There has been an error connecting to your container. Please
        <a href="/launch">restart or reconnect to it</a>
      </p>
    </ng-template>
    <ng-template [ngSwitchCase]="'418'">
      <h2>I'm a teapot</h2>
      <p>
        <img
          src="https://images-eu.ssl-images-amazon.com/images/I/41bbDR3wffL._SL500_AC_SS350_.jpg"
          alt="multi-coloured teapot" />
      </p>
    </ng-template>
    <ng-template [ngSwitchCase]="'401'">
      <h2>Not Authorized</h2>
      <p>Authorization is needed to access this resource. Please log in.</p>
    </ng-template>
    <ng-template [ngSwitchCase]="'403'">
      <h2>Access Forbidden</h2>
      <p>You are not permitted to access this resource</p>
    </ng-template>
    <ng-template ngSwitchDefault>
      <!-- 404 -->
      <h2>Page not found</h2>
      <p>The page you have requested cannot be found. Please check the URL and try again.</p>
      <p>
        <code>Error code</code> raised was <code>{{ code }}</code>
      </p>
    </ng-template>
  </ng-container>
</article>
